export default __webpack_public_path__ + "static/media/gallery_03.4c61669c.jpg";